<template>
  <div class="checklistItem">
    <div>
      <small>{{ fileName }}</small>
    </div>
    <sx-icon name="remove" :size="20"></sx-icon>
  </div>
</template>

<script>
import SxIcon from './SxIcon';
import SxSmall from './SxSmall';

export default {
  components: {
    SxIcon,
    SxSmall,
  },
  props: {
    fileName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.checklistItem {
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: space-between;
  padding: 8px;

  background-color: var(--gray-0);
  border-radius: 6px;
  box-shadow: 0px 1px 1px 0px rgba(114, 113, 125, 0.25);
  color: var(--blue-500);
  transition: all 80ms ease-in-out;

  cursor: pointer;
  line-height: 20px;
}

.checklistItem:hover {
  background-color: var(--blue-25);
}

.checklistItem small {
  display: block;

  color: var(--gray-600);

  font-size: var(--small-font-size);
  line-height: var(--small-line-height-);
  text-align: left !important;
  word-wrap: break-word;
}

.checklistItem svg {
  color: var(--gray-500) !important;
}

.checklistItem:hover svg {
  color: var(--gray-800);
}
</style>
